"use client";
import CategoriesBar from "../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../globalcomponents/navbar/NavbarTwo";
import CheckoutCard from "./checkOutCard/CheckoutCard";
import DetailPageMaxImg from "./detailapageimages/DetailPageMaxImg";
import DetailPageMiniImages from "./detailapageimages/DetailPageMiniImages";
import DetailPageMoreInformation from "./detailpagemoreinfo/DetailPageMoreInformation";
import DetailPageOffers from "./detailpageoffers/DetailPageOffers";
import DetailPagePolicies from "./detailpagepolicies/DetailPagePolicies";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { RootState } from "../../../store";
import { useCart } from "../../../context/CartContext";
import {
  AddToCartRequest,
  CartType,
  ProductType,
} from "../../../Redux/custmoer_cart_service/types";

import { HomePageProvider } from "../homepage/HomePageContext";
import { recordActivity } from "../../../Redux/ActivityApi/slice";
import { ActivityType } from "../../../Redux/ActivityApi/types";
import ProudtcDetails from "./detailpagedetails/ProudtcDetails";
import { useAuth } from "../../../context/AuthContext";
import { getDigitalProductById } from "../../../Redux/digital-product/slice";
import SideCart from "../../globalcomponents/SideCart/SideCart";

const DigitalProductDetails = () => {
  const id = useParams().id;
  const dispatch = useAppDispatch();
  const { currentProduct, loading, error } = useAppSelector(
    (state: RootState) => state.digitalProduct,
  );

  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // State for selected image
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [selectedVideo, setSelectedVideo] = useState<string>("");

  // State for selected variation
  const [selectedVariation, setSelectedVariation] = useState<number>(0);

  const { addItemToCart, loading: cartLoading, error: cartError } = useCart();

  useEffect(() => {
    if (id) {
      dispatch(getDigitalProductById(id as string));
    }
  }, [dispatch, id]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (currentProduct && id) {
      timer = setTimeout(() => {
        dispatch(
          recordActivity({
            activities: {
              eventType: ActivityType.VIEW_PRODUCT,
              productId: id as string,
            },
          }),
        );
      }, 5000); // Record after 5 seconds
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [currentProduct, id, dispatch]);

  useEffect(() => {
    if (currentProduct) {
      if (
        currentProduct.galleryImages &&
        currentProduct.galleryImages.length > 0
      ) {
        setSelectedImage(currentProduct.galleryImages[0]);
      }
      // Reset selected variation to first variation when product changes
      setSelectedVariation(0);
    }
  }, [currentProduct]);

  // Handler for image selection
  const handleImageSelect = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setSelectedVideo(""); // Clear video selection when image is selected
  };

  const handleVideoSelect = (videoUrl: string) => {
    setSelectedVideo(videoUrl);
    setSelectedImage(""); // Clear image selection when video is selected
  };

  const handleAddToCart = async () => {
    if (!isAuthenticated) {
      navigate("/SignIn");
      return;
    }
    if (!currentProduct) return;

    const addToCartData: AddToCartRequest = {
      productId: currentProduct.productID,
      productName: currentProduct.productName,
      productImage: currentProduct.productImages,
      productType: ProductType.DIGITAL,
      variantId: currentProduct.ssin,
      variantName: currentProduct.productName,
      quantity: 1,
      unitPrice: currentProduct?.pricingDetails?.unitPrice,
      sellerId: currentProduct?.sellerDetails?.sellerID,
      sellerName: currentProduct?.sellerDetails?.sellerName,
      isAdminProduct: currentProduct.createdBy==="ADMIN" ? true : false,

    };

    try {
      const resultAction = await addItemToCart(addToCartData, CartType.ECOMMERCE);

      // Guests get a sign-in toast + redirect from CartContext instead
      if (!resultAction) return;

      const addToCart_fulfilled = (action: any) => action.type.endsWith("/fulfilled");

      if (addToCart_fulfilled(resultAction)) {
        // Automatically open the side cart
        const offcanvasElement = document.getElementById("offcanvasMiniCart");
        if (offcanvasElement) {
          const bootstrap = (window as any).bootstrap;
          if (bootstrap && (window as any).bootstrap.Offcanvas) {
            const bsOffcanvas = new (window as any).bootstrap.Offcanvas(
              offcanvasElement,
            );
            bsOffcanvas.show();
          }
        }
      } else {
        alert(cartError || "Failed to add item to cart");
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };

  return (
    <HomePageProvider>
      <div className=" display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className=" container">
          <div className=" row d-flex justify-content-center pt-3 ">
            <div className=" col-lg-4">
              <div className=" d-flex justify-content-start gap-3 position-sticky top-1">
                <div>
                  <DetailPageMiniImages
                    images={currentProduct?.galleryImages || []}
                    videos={[]}
                    onImageSelect={handleImageSelect}
                    selectedImage={selectedImage}
                    onVideoSelect={handleVideoSelect}
                    selectedVideo={selectedVideo}
                  />
                </div>
                <div>
                  <DetailPageMaxImg
                    selectedImage={selectedImage}
                    selectedVideo={selectedVideo}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-5 p-3">
              <ProudtcDetails
                product={currentProduct as any}
                selectedVariation={selectedVariation}
              />

              {/* <DetailPagePolicies product={currentProduct?.product as any} /> */}
              <hr className=" horizontal dark" />

              <DetailPageMoreInformation
                product={currentProduct as any}
                selectedVariation={selectedVariation}
              />
            </div>
            <div className="col-lg-2">
              <CheckoutCard
                product={currentProduct as any}
                selectedVariation={selectedVariation}
                onAddToCart={handleAddToCart}
                isLoading={cartLoading}
              />
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" d-flex justify-content-between align-items-center p-2 shadow-card bg-white position-fixed w-100 z-index-3">
          <div>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href="/HomePage">
                <i className="ri-arrow-left-s-line fs-3 me-1 text-black"></i>
              </a>
            </li>
          </div>
          <div className=" d-flex gap-2">
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-search fs-6 text-black"></i>
              </a>
            </li>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-bell fs-5 text-black"></i>
              </a>
            </li>
          </div>
        </div>
        <DetailPageMiniImages
          images={currentProduct?.galleryImages || []}
          videos={[]}
          onImageSelect={handleImageSelect}
          selectedImage={selectedImage}
          onVideoSelect={handleVideoSelect}
          selectedVideo={selectedVideo}
        />
        <div className=" card shadow border-top-edges border-1   p-1 w-97 mx-auto px-2">
          <ProudtcDetails
            product={currentProduct as any}
            selectedVariation={selectedVariation}
          />
          <hr className=" horizontal dark" />
          <div className=" text-start">
            <DetailPageOffers
              salarShoppingVouchers={
                currentProduct?.pricingDetails?.salarShoppingVoucher
              }
            />
            <hr className=" horizontal dark" />

            <hr className=" horizontal dark" />

            <DetailPagePolicies product={currentProduct as any} />
            <hr className=" horizontal dark" />
            <div className=" mb-2">
              <button
                className=" btn btn-md btn-yellow border-radius-40 w-100"
                onClick={handleAddToCart}
                disabled={cartLoading}
              >
                {cartLoading ? "Adding..." : "Add to Cart"}
              </button>
            </div>
            <div className=" mb-3">
              <button className=" btn btn-md btn-outline-dark border-radius-40 w-100">
                Add to wishlist
              </button>
            </div>
            <hr className=" horizontal dark" />
            <div className=" px-2"></div>
            <hr className=" horizontal dark" />
            <DetailPageMoreInformation
              product={currentProduct as any}
              selectedVariation={selectedVariation}
            />
          </div>
        </div>
        <div className=" card shadow-dark border-radius-00 p-2 mt-2 mb-2 w-95 mx-auto">
          <div className=" mt-0 mb-3 lh-0">
            <h5 className=" text-success fw-normal">In stock</h5>
            <div className=" mt-3 d-flex justify-content-lg-start align-items-center">
              <div className=" text-start w-100">
                <b className=" text-sm text-black fw-normal">Ships from</b>
              </div>
              <div className=" text-start w-100">
                <b className=" text-sm text-teal fw-normal">
                  {currentProduct?.sellerDetails?.region}
                </b>
              </div>
            </div>
            <div className=" mt-2 d-flex justify-content-lg-start align-items-center">
              <div className=" text-start w-100">
                <b className=" text-black text-sm fw-normal">Sold by</b>
              </div>
              <div className=" text-start w-100">
                <a href={`/SellerDetail/${id}`}>
                  <b className="  text-teal text-sm fw-normal">
                    {currentProduct?.sellerDetails?.sellerName}
                  </b>
                </a>
              </div>
            </div>
            <div className=" mt-2 d-flex justify-content-lg-start align-items-center">
              <div className=" text-start w-100">
                <b className=" text-black text-sm fw-normal">Payment</b>
              </div>
              <div className=" text-start w-100">
                <b className=" text-teal text-sm fw-normal">
                  Secure Transaction
                </b>
              </div>
            </div>
            <div className=" mt-2 d-flex justify-content-lg-start align-items-center">
              <div className=" text-start w-100">
                <b className="  text-black text-sm fw-normal">
                  {currentProduct?.pricingDetails?.salarShoppingVoucher
                    ? "Available"
                    : "Not Available"}
                </b>
              </div>
              <div className=" text-start w-100">
                <b className="text-teal text-sm fw-normal">Available</b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideCart />
      <div
        className="modal fade"
        id="sizeChartModal"
        role="dialog"
        aria-labelledby="sizeChartModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="sizeChartModalLabel">
                Size Guide
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <i className="bi bi-x fs-4 text-black"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </HomePageProvider>
  );
};

export default DigitalProductDetails;
